import { CatalogPingRepository, CatalogPingRepositorySpec } from '@headless-workspace/core-domain';
import {
    HomeSlotsRepository,
    HomeSlotsRepositorySpec,
    NewsletterSlotRepository,
    NewsletterSlotRepositorySpec,
    ReviewsRepository,
    ReviewsRepositorySpec,
    ReviewTranslationRepository,
    ReviewTranslationRepositorySpec,
} from '../../src';

export const HomeSlotsRepositoryType = 'HomeSlotsRepository';
export const CatalogPingRepositoryType = 'CatalogPingRepository';
export const NewsletterSlotRepositoryType = 'NewsletterSlotRepository';
export const ReviewsRepositoryType = 'ReviewsRepository';
export const ReviewsTranslationRepositoryType = 'ReviewsTranslationRepository';

export const deps = () => ({
    [HomeSlotsRepositoryType]: HomeSlotsRepository as new () => HomeSlotsRepositorySpec,
    [CatalogPingRepositoryType]: CatalogPingRepository as new () => CatalogPingRepositorySpec,
    [NewsletterSlotRepositoryType]: NewsletterSlotRepository as new () => NewsletterSlotRepositorySpec,
    [ReviewsRepositoryType]: ReviewsRepository as new () => ReviewsRepositorySpec,
    [ReviewsTranslationRepositoryType]: ReviewTranslationRepository as new () => ReviewTranslationRepositorySpec,
});
